<template>
  <div class="app_container">
    <search class="search-wrapper" @search="searchHandle" />
    <div class="table-column-check-list">
      <butn
        btntype="primary"
        title="导出"
        @click="exportExcel"
        v-permission="'enroll:exportXls'"
        :disabled="list.length <= 0"
      ></butn>
      <el-checkbox-group class="checkbox-group" v-model="tableColumnCheckList">
        <template
          v-for="(item, index) in tableColumn.filter((value) => value.checkbox)"
        >
          <el-checkbox :key="index" :label="item.prop">{{
            item.label
          }}</el-checkbox>
        </template>
      </el-checkbox-group>
    </div>
    <el-table
      ref="pageListTable"
      :data="list"
      border
      :span-method="objectSpanMethod"
      :row-style="{ color: '#51627D', fontWeight: 400 }"
      :header-row-style="{ color: '#343C4A', fontWeight: 500 }"
    >
      <template
        v-for="(item, index) in tableColumn.filter(
          (ele) => tableColumnCheckList.includes(ele.prop) || !ele.checkbox
        )"
      >
        <el-table-column
          :key="index"
          class-name="train-list-column"
          v-bind="item"
          :width="item.width"
        />
      </template>
    </el-table>
    <el-pagination
      class="pagination"
      @size-change="sizeChange"
      @current-change="pageChange"
      :current-page="currentPage"
      :page-size="size"
      :page-sizes="[10, 50, 100, 500, 1000]"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total"
      background
      hide-on-single-page
    />
  </div>
</template>

<script>
import Search from "./search";
import butn from "@/components/button/index";
import { pageStatisticsByParam, exportTrainInfo } from "@/api/trainingInfo";
export default {
  name: "trainingInfo",
  components: {
    Search,
    butn,
  },
  data() {
    return {
      list: [],
      dataname: {},
      currentPage: 1,
      size: 10,
      total: 0,
      tableColumn: [
        { prop: "userName", label: "姓名" },
        { prop: "userBirthday", label: "出生年月", minWidth: "100" },
        {
          prop: "userMobile",
          label: "手机号码",
          minWidth: "110",
          checkbox: true,
        },
        {
          prop: "deptName",
          label: "所属单位",
          minWidth: "100",
        },
        {
          prop: "unitPosition",
          label: "单位及职务",
          minWidth: "100",
          checkbox: true,
        },
        {
          prop: "leaderTypeName",
          label: "管理主体",
          minWidth: "100",
          checkbox: true,
        },
        {
          prop: "className",
          label: "班级名称",
          child: true,
          checkbox: true,
          minWidth: "170",
        },
        {
          prop: "trainTypeName",
          label: "培训类型",
          child: true,
          checkbox: true,
          minWidth: "120",
        },
        {
          prop: "trainTime",
          label: "培训时间",
          child: true,
          checkbox: true,
          showOverflowTooltip: true,
          minWidth: "170",
        },
        {
          prop: "trainDays",
          label: "学制",
          child: true,
          checkbox: true,
        },
        {
          prop: "isOnlineName",
          label: "办班方式",
          child: true,
          checkbox: true,
        },
        {
          prop: "organizer",
          label: "主办单位",
          child: true,
          checkbox: true,
          minWidth: "100",
        },
        {
          prop: "undertakeUnit",
          label: "承办单位",
          child: true,
          checkbox: true,
          minWidth: "100",
        },
        {
          prop: "trainPlace",
          label: "培训地点",
          child: true,
          checkbox: true,
        },
        {
          prop: "totalDays",
          label: "合计天数",
          checkbox: true,
        },
      ],
      tableColumnCheckList: [],
    };
  },
  created() {
    this.tableColumn.forEach((value) => {
      if (value.checkbox) {
        this.tableColumnCheckList.push(value.prop);
      }
    });
    this.getList();
  },
  methods: {
    //导出
    exportExcel() {
      let param = { ...this.dataname };
      exportTrainInfo(param).then((response) => {
        let data = response.data;
        let fileReader = new FileReader();
        let _this = this;
        fileReader.onload = function () {
          try {
            let jsonData = JSON.parse(this.result);
            if (jsonData.code) {
              _this.$message({
                message: jsonData.msg,
                type: "error",
              });
            }
          } catch (e) {
            let blob = new Blob([response.data], {
              type: "application/vnd.ms-excel",
            }); //创建一个blob对象
            const uA = window.navigator.userAgent;
            const isIE =
              /msie\s|trident\/|edge\//i.test(uA) &&
              !!(
                "uniqueID" in document ||
                "documentMode" in document ||
                "ActiveXObject" in window ||
                "MSInputMethodContext" in window
              );
            let a = document.createElement("a"); //创建一个<a></a>标签
            let href = window.URL.createObjectURL(blob); // response is a blob
            a.href = href;
            let title = decodeURI(escape(response.headers.downloadname)); //文件名称
            a.download = title;
            a.style.display = "none";
            document.body.appendChild(a);
            if (isIE) {
              // 兼容IE11无法触发下载的问题
              navigator.msSaveBlob(blob, title);
            } else {
              a.click();
            }
            document.body.removeChild(a); // 下载完成移除元素
            // window.URL.revokeObjectURL(href); // 释放url
          }
        };
        fileReader.readAsText(data);
        // 更新列表
        this.searchHandle(this.dataname);
      });
    },
    //   搜索
    searchHandle(params) {
      this.dataname = params;
      this.getList();
    },
    objectSpanMethod({ row, column }) {
      if (
        [
          "main",
          "userName",
          "userBirthday",
          "userMobile",
          "deptName",
          "leaderTypeName",
          "unitPosition",
          "totalDays",
        ].indexOf(column.property) > -1
      ) {
        return row.span[0];
      }
    },
    getList() {
      pageStatisticsByParam({
        ...this.dataname,
        page: this.currentPage,
        limit: this.size,
      }).then((res) => {
        if (!res || res.code != 0) return;
        this.total = res.data.total;
        let flatList = [];
        if (Array.isArray(res.data.records) && res.data.records.length) {
          for (
            let userIndex = 0, userLen = res.data.records.length;
            userIndex < userLen;
            userIndex++
          ) {
            const user = res.data.records[userIndex];
            if (
              Array.isArray(user.classInfoVoList) &&
              user.classInfoVoList.length
            ) {
              let mergeFirst;
              for (
                let classIndex = 0, classLen = user.classInfoVoList.length;
                classIndex < classLen;
                classIndex++
              ) {
                const classItem = user.classInfoVoList[classIndex];
                const newItem = Object.assign({}, user, classItem);
                delete newItem.classInfoVoList;
                newItem.ukey = newItem.uuid + "_";
                flatList.push(newItem);
                if (classLen === 1) {
                  newItem.span = [
                    { rowspan: 1, colspan: 1 },
                    { rowspan: 1, colspan: 1 },
                  ];
                } else {
                  let span0 = { rowspan: 0, colspan: 0 };
                  if (classIndex === 0) {
                    span0 = { rowspan: classLen, colspan: 1 };
                  }

                  let span1 = { rowspan: 1, colspan: 1 };
                  if (classIndex > 0) {
                    const prevClassItem = user.classInfoVoList[classIndex - 1];
                    if (classItem.then_job === prevClassItem.then_job) {
                      if (!mergeFirst) {
                        mergeFirst = prevClassItem;
                      }
                      mergeFirst.span[1].rowspan++;
                      span1 = {
                        rowspan: 0,
                        colspan: 0,
                      };
                    } else {
                      mergeFirst = undefined;
                    }
                  }
                  classItem.span = newItem.span = [span0, span1];
                }
              }
            } else {
              user.span = [
                { rowspan: 1, colspan: 1 },
                { rowspan: 1, colspan: 1 },
              ];
              user.ukey = user.uuid;
              flatList.push(user);
            }
          }
        }
        this.list = flatList;
      });
    },
    sizeChange(size) {
      this.size = size;
      this.getList();
    },
    pageChange(page) {
      this.currentPage = page;
      this.getList();
    },
  },
  computed: {
    examPaperIds() {
      return this.checkArray.map((item) => item.uuid);
    },
  },
};
</script>

<style lang="scss" scoped>
.pagination {
  margin-top: 10px;
}
.table-column-check-list {
  margin-bottom: 10px;
  /deep/ .el-checkbox-group {
    display: inline;
    margin-left: 20px;
    .el-checkbox {
      margin-right: 15px;
      margin-bottom: 10px;
    }
  }
}
</style>
